import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HighAvailabilitySettings } from '../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';

@Injectable()
export class HighAvailabilityResource {
  private $http = inject(HttpClient);

  ziroIcons = ZiroIcons;

  private _baseUrl = `/services/cisco/admin/high-availability`;

  getHaSettings(): Observable<HighAvailabilitySettings> {
    return this.$http.get<HighAvailabilitySettings>(this._baseUrl + `/settings`);
  }

  putHaSettings(settings: HighAvailabilitySettings): Observable<void> {
    return this.$http.put<void>(this._baseUrl + `/settings`, settings);
  }

  postReplication(requestUrl: string): Observable<void> {
    return this.$http.post<void>(this._baseUrl + `/replication`, { url: requestUrl });
  }

  postHaValidation(requestUrl: string): Observable<void> {
    return this.$http.post<void>(this._baseUrl + '/validation', { url: requestUrl });
  }
}
